import { useMutation } from 'react-query';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';

import { routeReplacer } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';

export const useRequestInviteCustomer = () => {
  const { currentProvider } = useProvider();

  return useMutation(async (customerId: string) => {
    const response = await requestReactQuery<any>({
      url: routeReplacer(CORE_SERVICE_URLS.INVITE_CUSTOMER, {
        providerId: currentProvider?.uuid || '',
        id: customerId,
      }),
      config: { method: 'POST' },
    });

    return response;
  });
};
